import doShippingModalTemplate from '../views/contact-actions/do-shipping-modal.tpl.html';
import preparePickupModalTemplate from '../views/contact-actions/prepare-pickup-modal.tpl.html';

class ContactActionsService {
    constructor($uibModal, FileSaver, $http) {
        this.modal = $uibModal;
        this.fileSaver = FileSaver;
        this.api = $http;
    }

    startShippingWorkflow(contact) {
        return this.modal.open({
            controller: 'DoShippingModalController',
            controllerAs: 'vm',
            size: 'lg',
            templateUrl: doShippingModalTemplate,
            resolve: {
                contactId() {
                    return contact.id;
                }
            }
        }).result;
    }

    startPreparePickupWorkflow(contact) {
        return this.modal.open({
            controller: 'PrepareContactPickupModalController',
            controllerAs: 'vm',
            size: 'lg',
            templateUrl: preparePickupModalTemplate,
            resolve: {
                contactId() {
                    return contact.id;
                }
            }
        }).result;
    }
}

/**
 * @ngdoc service
 * @name contacts.services:ContactActionsService
 *
 * @description
 *
 */
angular
    .module('festzelt-os.contacts')
    .factory('ContactActionsService', [
        '$uibModal',
        'FileSaver',
        '$http',
        ($uibModal, FileSaver, $http) => new ContactActionsService($uibModal, FileSaver, $http)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/contacts/services/contact-actions-service.js